//========== Star Animation Background Section Component ==========

import "../../styles/css/vendor/dots.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StarAnimation = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "full-wh",
    children: /*#__PURE__*/_jsxs("div", {
      className: "bg-animation",
      children: [/*#__PURE__*/_jsx("div", {
        id: "stars"
      }), /*#__PURE__*/_jsx("div", {
        id: "stars2"
      }), /*#__PURE__*/_jsx("div", {
        id: "stars3"
      }), /*#__PURE__*/_jsx("div", {
        id: "stars4"
      })]
    })
  });
};
export default StarAnimation;